import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

import { formatProviderTagError } from "../utils/formatProviderTagError";

export async function deleteProviderTag(tagId: string): Promise<void> {
  const { error } = await apiClient
    .from('provider_tags')
    .delete()
    .eq('id', tagId);

  if (error) {
    throw new Error(formatProviderTagError(error, 'Erreur lors de la suppression du tag.'));
  }
}

export function useDeleteProviderTag() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();
  const spaceId = currentSpace?.id ?? '';

  return useMutation({
    mutationFn: (tagId: string) => deleteProviderTag(tagId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.tags(spaceId) });
      queryClient.invalidateQueries({ queryKey: keys.getProvidersList(spaceId) });
    },
  });
}

